"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlowQueriesTable = SlowQueriesTable;
const react_1 = __importDefault(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const Utils_1 = require("../../utils/Utils");
const EmptyAlert_1 = __importDefault(require("../../components/Shared/Alerts/EmptyAlert"));
function SlowQueriesTable({ rows }) {
    const columns = [
        { dataField: 'occurred_at', text: 'Date', formatter: (cell) => new Date(cell).toLocaleString(), sort: true },
        { dataField: 'endpoint', text: 'Endpoint', sort: true },
        { dataField: 'method', text: 'Méthode', sort: true },
        { dataField: 'duration_ms', text: 'Durée', formatter: (v, r) => (react_1.default.createElement("span", { className: v >= r.slow_threshold_ms ? 'badge bg-warning' : 'badge bg-success' }, (0, Utils_1.fmtMs)(v))), sort: true },
        { dataField: 'sql', text: 'SQL', formatter: (cell) => react_1.default.createElement("span", { className: "code", title: cell || '' }, cell) },
    ];
    return (react_1.default.createElement("div", { className: "admin-table" },
        react_1.default.createElement(react_bootstrap_table_next_1.default, { bootstrap4: true, keyField: "occurred_at", data: rows || [], columns: columns, classes: "table table-striped mb-0", wrapperClasses: "table-responsive admin-table", noDataIndication: () => (react_1.default.createElement(EmptyAlert_1.default, { textualContent: "Aucune donn\u00E9es trouv\u00E9es" })), bordered: false, condensed: true, defaultSorted: [{ dataField: 'duration_ms', order: 'desc' }] })));
}
